export enum IncidentType {
    Tyre = 0,
    Mechanical = 1,
    Both = 2
}

export enum TyreLocation {
    steer = 1,
    drive = 2,
    trailer = 3,
    spare = 4
}

export enum UserType {
    unknown = 0,
    truckdriver = 1,
    operator = 2,
    callcenterOperator = 3,
    serviceProviderOperator = 4,
    technician = 5
}

export enum ClientType{
    fleet = 1,
    call_centre = 2,
    service_provider = 3
}

export enum IncidentStatusCategory {
  Open = 1,
  Closed = 2,
  Past = 3
}

export enum WaGroupFlag {
  Unknown            = 0,
  DirectToBDTech     = 1,   // 0001
  ThirdPartySP       = 2,   // 0010
  SPControlsBDTech   = 4,   // 0100
  CallCentre         = 8,   // 1000
  HasBDTechAssigned  = 16,  // 10000
  Fleet              = 32   // 100000
}
